import React from 'react';
import { TimeseriesContext } from './Timeseries.Context';

export const TimeseriesPanelContext = React.createContext(null);

const { Provider: TSPProvider } = TimeseriesPanelContext;

export default function TimeseriesPanelProvider({ children }) {
  const {
    date, pageSize, meteocodes, calcModuleParams, confines, meteocodeFilter,
  } = React.useContext(TimeseriesContext);
  const [localDateTime, setLocalDateTime] = React.useState(date);
  const [localPageSize, setLocalPageSize] = React.useState(pageSize);
  const [localCalcParams, setLocalCalcParams] = React.useState(calcModuleParams);
  const [selectedMeteocodes, setSelectedMeteocodes] = React.useState([]);
  const [selectedConfines, setSelectedConfines] = React.useState([]);

  const [selectedMeteocodeFilter, setSelectedMeteocodeFilter] = React.useState('entity');

  React.useEffect(() => {
    if (date) {
      setLocalDateTime(date);
    }
  }, [date]);

  React.useEffect(() => {
    if (pageSize) {
      setLocalPageSize(pageSize);
    }
  }, [pageSize]);

  React.useEffect(() => {
    if (meteocodes.length > 0) {
      setSelectedMeteocodes(meteocodes);
    }
  }, [meteocodes]);

  React.useEffect(() => {
    setSelectedConfines(confines);
  }, [confines]);

  React.useEffect(() => {
    if (calcModuleParams) {
      setLocalCalcParams(calcModuleParams);
    }
  }, [calcModuleParams]);

  React.useEffect(() => {
    if (meteocodeFilter) {
      setSelectedMeteocodeFilter(meteocodeFilter);
    }
  }, [meteocodeFilter]);

  const params = {
    localDateTime,
    localPageSize,
    localCalcParams,
    selectedMeteocodes,
    selectedConfines,
    setLocalDateTime,
    setLocalPageSize,
    setSelectedMeteocodes,
    setLocalCalcParams,
    setSelectedConfines,
    selectedMeteocodeFilter,
    setSelectedMeteocodeFilter,
  };

  return (
    <TSPProvider value={params}>
      {children}
    </TSPProvider>
  );
}
